const form = document.querySelector('form');
const header = document.querySelector('header');
const loginPage = document.querySelector('.login-page');
const togglePasswordButtons = document.querySelectorAll('.allos-input-eye');

const loginSection = document.querySelector('.login-page__container');
const emailInput = document.getElementById('input-email');
const passwordInput = document.getElementById('input-password');
const submitButton = document.getElementById('submit-form');
const emailError = document.getElementById('email-error');
const passwordError = document.getElementById('password-error');
const forgotPasswordLink = document.getElementById('forgot-password');

const resetSection = document.querySelector('.login-page__reset-password');

const emailForm = document.getElementById('email-form');
const emailInputValidation = document.getElementById('input-email-validation');
const emailErrorValidation = document.getElementById('email-error-validation');
const sendResetButton = document.getElementById('send-reset');
const backToLoginButton = document.getElementById('back-to-login');

const tokenForm = document.getElementById('token-form');
const tokenInputValidation = document.getElementById('input-token-validation');
const tokenErrorValidation = document.getElementById('token-error-validation');
const resendTokenLink = document.getElementById('resend-token');
const sendTokenButton = document.getElementById('send-token');
const backToSendResetButton = document.getElementById('back-to-send-reset');

const newPasswordForm = document.getElementById('new-password-form');
const newPasswordInput = document.getElementById('input-new-password');
const newPasswordConfirmationInput = document.getElementById('input-confirm-new-password');
const newPasswordErrorValidation = document.getElementById('new-password-error-validation');
const confirmNewPasswordErrorValidation = document.getElementById(
  'confirm-new-password-error-validation'
);
const updatePasswordButton = document.getElementById('update-password');
const backToSendTokenLink = document.getElementById('back-to-send-token');

const successForm = document.getElementById('success-form');
const goToLoginButton = document.getElementById('go-to-login');

let emailForgotPassword = '';
let tokenForgotPassword = '';

function preventCopyPaste(event) {
  if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) {
    event.preventDefault();
  }
}

function mascararEmail(email) {
  const partes = email.split('@'); // Divide o email em duas partes: nome de usuário e domínio
  const usuario = partes[0];
  const dominio = partes[1];

  const usuarioMascarado = usuario.substring(0, 3) + '*'.repeat(usuario.length - 3); // Mantém os 3 primeiros caracteres e substitui o restante por asteriscos
  const dominioMascarado = dominio.substring(0, 2) + '*'.repeat(dominio.length - 2); // Mantém os 2 primeiros caracteres do domínio e substitui o restante por asteriscos

  return usuarioMascarado + '@' + dominioMascarado;
}

document.getElementById('input-confirm-new-password').addEventListener('keydown', preventCopyPaste);

function isValidEmail(email) {
  // Esta é uma expressão regular básica para validar o formato de e-mail.
  // Existem muitas variações disponíveis online, algumas mais estritas e outras mais permissivas.
  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return regex.test(email);
}

function allFieldsHaveValue(fields) {
  return fields.every(field => field.value !== '');
}

const configurations = [
  {
    button: sendResetButton,
    inputs: [emailInputValidation],
  },
  {
    button: sendTokenButton,
    inputs: [tokenInputValidation],
  },
  {
    button: updatePasswordButton,
    inputs: [newPasswordInput, newPasswordConfirmationInput],
  },
];

configurations.forEach(config => {
  config.inputs.forEach(input => {
    input.addEventListener('input', () => {
      config.button.disabled = !allFieldsHaveValue(config.inputs);
    });
  });
});

async function obterUrlRedirecionamento() {
  try {
    const redirectResponse = await fetch('/api/loginAdministracao/solicitaUrlRedirecionamento', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (redirectResponse.status === 200) {
      return redirectResponse.url;
    } else {
      console.error('Erro ao obter a URL de redirecionamento do servidor');
      return null;
    }
  } catch (error) {
    console.error('Ocorreu um erro ao obter a URL de redirecionamento: ', error);
    return null;
  }
}

async function realizaLogin(username, password) {
  try {
    const emailValue = username.trim();
    const passwordValue = password.trim();

    let hasError = false;

    if (emailValue === '') {
      emailInput.classList.add('error');
      emailError.querySelector('.error-text').textContent = 'Insira seu e-mail e tente novamente';
      emailError.style.display = 'flex';

      hasError = true;
    } else {
      emailInput.classList.remove('error');
      emailError.style.display = 'none';
    }

    if (passwordValue === '') {
      passwordInput.classList.add('error');
      passwordError.querySelector('.error-text').textContent = 'Insira sua senha e tente novamente';
      passwordError.style.display = 'flex';

      hasError = true;
    } else {
      passwordInput.classList.remove('error');
      passwordError.style.display = 'none';
    }

    if (hasError) {
      submitButton.classList.remove('button--loading');
      return;
    }

    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);

    const response = await fetch('/lumis/api/rest/lumlogin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData,
    });

    if (response.status === 204) {
      const redirectUrl = await obterUrlRedirecionamento();

      if (redirectUrl) {
        window.location.href = redirectUrl;
        submitButton.classList.remove('button--loading');
      } else {
        console.error('A resposta não contém um cabeçalho de Location.');
      }
    } else if (response.status === 403) {
      passwordInput.classList.add('error');
      passwordError.querySelector('.error-text').textContent =
        'Usuário ou senha incorretos, verifique e tente novamente';
      passwordError.style.display = 'flex';

      submitButton.classList.remove('button--loading');
    } else if (response.status === 400) {
      console.error('Usuário não fornecido na requisição');
    } else {
      console.error('Erro inesperado durante o processamento da requisição');
    }
  } catch (error) {
    console.error('Ocorreu um erro inesperado: ', error);
  }
}

async function solicitarAlteracaoSenha(email) {
  try {
    const response = await fetch('/api/loginAdministracao/solicitaAlteracaoSenha', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!isValidEmail(email)) {
      emailInputValidation.classList.add('error');
      emailErrorValidation.querySelector('.error-text').textContent =
        'Favor, informe um e-mail válido';
      emailErrorValidation.style.display = 'flex';

      sendResetButton.classList.remove('button--loading');
    } else {
      if (response.status === 200) {
        setTimeout(() => {
          sendResetButton.classList.remove('button--loading');

          emailForm.style.display = 'none';
          tokenForm.style.display = 'flex';
        }, 1000);

        emailForgotPassword = email;
        const emailMascarado = mascararEmail(emailForgotPassword);

        document.getElementById('token-form').querySelector('p > b').textContent = emailMascarado;
      } else if (response.status === 403) {
        emailInputValidation.classList.add('error');
        emailErrorValidation.querySelector('.error-text').textContent =
          'Você realizou requisições demais, tente novamente mais tarde';
        emailErrorValidation.style.display = 'flex';

        sendResetButton.classList.remove('button--loading');
      } else {
        console.error('Ocorreu um erro durante a solicitação de alteração de senha.');
      }
    }
  } catch (error) {
    console.error('Ocorreu um erro inesperado: ', error);
  }
}

async function validaToken(email, token) {
  try {
    const response = await fetch(
      `/api/loginAdministracao/validaToken?email=${email}&token=${token}`
    );

    if (response.status === 200) {
      const isValid = await response.text();

      if (isValid === 'true') {
        tokenForgotPassword = token;

        setTimeout(() => {
          sendTokenButton.classList.remove('button--loading');

          tokenForm.style.display = 'none';
          newPasswordForm.style.display = 'flex';
        }, 1000);
      } else if (isValid === 'false') {
        tokenInputValidation.classList.add('error');
        tokenErrorValidation.querySelector('.error-text').textContent =
          'Código incorreto, tente novamente';
        tokenErrorValidation.style.display = 'flex';

        sendTokenButton.classList.remove('button--loading');
      }
    } else if (response.status === 403) {
      const resposeText = await response.text();
      const isExpired = resposeText === 'Token Expirado';

      if (isExpired) {
        tokenInputValidation.classList.add('error');
        tokenErrorValidation.querySelector('.error-text').textContent =
          'Código expirado, solicite um novo';
        tokenErrorValidation.style.display = 'flex';

        sendTokenButton.classList.remove('button--loading');
      } else {
        console.error('O email não corresponde a nenhum usuário.');
      }
    } else {
      console.error('Ocorreu um erro durante a validação do token.');
    }
  } catch (error) {
    console.error('Ocorreu um erro inesperado: ', error);
  }
}

async function alterarSenha(email, token, novaSenha) {
  try {
    const response = await fetch('/api/loginAdministracao/alteraSenha', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, token, novaSenha }),
    });

    if (response.status === 200) {
      setTimeout(() => {
        updatePasswordButton.classList.remove('button--loading');

        newPasswordForm.style.display = 'none';
        successForm.style.display = 'flex';
      }, 1000);
    } else if (response.status === 403) {
      console.error('Usuário/token incorreto.');
    } else if (response.status === 409) {
      console.error('A senha não corresponde às especificações mínimas de segurança.');
    } else {
      console.error('Ocorreu um erro durante a alteração de senha.');
    }
  } catch (error) {
    console.error('Ocorreu um erro inesperado: ', error);
  }
}

function adjustHeaderVisibility() {
  if (getComputedStyle(loginSection).display === 'none') {
    header.style.display = 'flex';
    loginPage.classList.add('reset-password--active');
  } else {
    header.style.display = 'none';
    loginPage.classList.remove('reset-password--active');
  }
}

// Chamada inicial para configurar corretamente o header
adjustHeaderVisibility();

togglePasswordButtons.forEach(button => {
  button.addEventListener('click', () => {
    const associatedInput = document.getElementById(button.dataset.inputId);

    if (associatedInput) {
      const currentType = associatedInput.getAttribute('type');
      const newType = currentType === 'password' ? 'text' : 'password';
      associatedInput.setAttribute('type', newType);
      button.classList.toggle('bi-eye');
    }
  });
});

form.addEventListener('submit', e => {
  e.preventDefault();
});

/* Form submit */

submitButton.addEventListener('click', e => {
  submitButton.classList.add('button--loading');

  e.preventDefault();

  emailInput.classList.remove('error');
  passwordInput.classList.remove('error');
  emailError.style.display = 'none';
  passwordError.style.display = 'none';
  emailError.querySelector('.error-text').textContent = '';
  passwordError.querySelector('.error-text').textContent = '';

  realizaLogin(emailInput.value, passwordInput.value);
});

/* Fluxo de esqueci senha */

// Mostrar seção de redefinição de senha e ocultar formulário de login
forgotPasswordLink.addEventListener('click', e => {
  e.preventDefault();

  loginSection.style.display = 'none';
  resetSection.style.display = 'flex';

  adjustHeaderVisibility();
});

backToSendResetButton.addEventListener('click', e => {
  e.preventDefault();

  tokenForm.style.display = 'none';
  emailForm.style.display = 'flex';
});

backToSendTokenLink.addEventListener('click', e => {
  e.preventDefault();

  newPasswordForm.style.display = 'none';
  tokenForm.style.display = 'flex';
});

goToLoginButton.addEventListener('click', e => {
  e.preventDefault();

  document
    .querySelectorAll('input[type="text"], input[type="email"], input[type="password"]')
    .forEach(input => {
      input.value = '';
    });

  newPasswordErrorValidation.querySelectorAll('li').forEach(rule => {
    rule.classList.remove('valid');
    rule.querySelector('.bi').classList.remove('bi-check2');
    rule.querySelector('.bi').classList.add('bi-dot');
  });

  resetSection.style.display = 'none';
  successForm.style.display = 'none';
  emailForm.style.display = 'flex';
  loginSection.style.display = 'flex';

  adjustHeaderVisibility();
});

// Mostrar formulário de login e ocultar seção de redefinição de senha
backToLoginButton.addEventListener('click', e => {
  e.preventDefault();

  loginSection.style.display = 'flex';
  resetSection.style.display = 'none';

  adjustHeaderVisibility();

  emailErrorValidation.style.display = 'none';
  emailErrorValidation.querySelector('.error-text').textContent = '';
  emailInputValidation.value = '';
});

sendResetButton.addEventListener('click', e => {
  sendResetButton.classList.add('button--loading');

  e.preventDefault();

  emailInputValidation.classList.remove('error');
  emailErrorValidation.style.display = 'none';
  emailErrorValidation.querySelector('.error-text').textContent = '';

  solicitarAlteracaoSenha(emailInputValidation.value);
});

resendTokenLink.addEventListener('click', e => {
  solicitarAlteracaoSenha(emailForgotPassword);
});

sendTokenButton.addEventListener('click', e => {
  sendTokenButton.classList.add('button--loading');

  e.preventDefault();

  tokenInputValidation.classList.remove('error');
  tokenErrorValidation.style.display = 'none';
  tokenErrorValidation.querySelector('.error-text').textContent = '';

  validaToken(emailForgotPassword, tokenInputValidation.value);
});

/* Nova senha */

function validateOnInput() {
  const password = newPasswordInput.value;

  // Verifique cada regra e adicione/remova uma classe conforme necessário
  toggleValidationClassOnInput(
    document.getElementById('rule-uppercase-lowercase'),
    /[A-Z]/.test(password) && /[a-z]/.test(password)
  );
  toggleValidationClassOnInput(document.getElementById('rule-number'), /\d/.test(password));
  toggleValidationClassOnInput(document.getElementById('rule-symbol'), /[@\-!_#]/.test(password));
  toggleValidationClassOnInput(
    document.getElementById('rule-length'),
    isPasswordLengthValid(password.length)
  );
}

function isPasswordLengthValid(length){
  return length >= 12;
}

function validateOnBlur() {
  const password = newPasswordInput.value;

  toggleValidationClassOnBlur(
    document.getElementById('rule-uppercase-lowercase'),
    /[A-Z]/.test(password) && /[a-z]/.test(password)
  );
  toggleValidationClassOnBlur(document.getElementById('rule-number'), /\d/.test(password));
  toggleValidationClassOnBlur(document.getElementById('rule-symbol'), /[@\-!_#]/.test(password));
  toggleValidationClassOnBlur(
    document.getElementById('rule-length'),
      isPasswordLengthValid(password.length)
  );
}

function toggleValidationClassOnInput(element, isValid) {
  const icon = element.querySelector('.bi');
  if (isValid) {
    element.classList.add('valid');
    element.classList.remove('invalid');
    icon.classList.remove('bi-exclamation-circle');
    icon.classList.remove('bi-dot');
    icon.classList.add('bi-check2');
  } else {
    icon.classList.remove('bi-check2');
    icon.classList.add('bi-dot');
    element.classList.remove('valid');
  }
}

function toggleValidationClassOnBlur(element, isValid) {
  const icon = element.querySelector('.bi');
  if (!isValid) {
    element.classList.add('invalid');
    icon.classList.remove('bi-check2');
    icon.classList.add('bi-exclamation-circle');
  } else {
    element.classList.remove('invalid');
    icon.classList.remove('bi-exclamation-circle');
    icon.classList.add('bi-check2');
  }
}

function arePasswordRequirementsMet() {
  const password = newPasswordInput.value;
  return (
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /\d/.test(password) &&
    /[@\-!_#]/.test(password) &&
    isPasswordLengthValid(password.length)
  );
}

newPasswordInput.addEventListener('input', validateOnInput);
newPasswordInput.addEventListener('blur', validateOnBlur);

updatePasswordButton.addEventListener('click', e => {
  updatePasswordButton.classList.add('button--loading');

  e.preventDefault();

  if (!arePasswordRequirementsMet()) {
    newPasswordConfirmationInput.classList.add('error');
    confirmNewPasswordErrorValidation.querySelector('.error-text').textContent =
      'A senha não atende todos os requisitos acima';
    confirmNewPasswordErrorValidation.style.display = 'flex';
    updatePasswordButton.classList.remove('button--loading');

    return;
  }

  newPasswordConfirmationInput.classList.remove('error');
  confirmNewPasswordErrorValidation.style.display = 'none';
  confirmNewPasswordErrorValidation.querySelector('.error-text').textContent = '';

  if (newPasswordInput.value !== newPasswordConfirmationInput.value) {
    newPasswordConfirmationInput.classList.add('error');
    confirmNewPasswordErrorValidation.querySelector('.error-text').textContent =
      'Senhas não coincidem, tente novamente';
    confirmNewPasswordErrorValidation.style.display = 'flex';
    updatePasswordButton.classList.remove('button--loading');
  } else {
    alterarSenha(emailForgotPassword, tokenForgotPassword, newPasswordConfirmationInput.value);
  }
});
